import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const reportIssueSchema = z.object({
  reason: z.string({ error: "Reason is a required field" }),
  comment: z
    .string({ error: "Please enter a comment" })
    .min(1, "Comment can't be blank, please enter a comment"),
  complaintPhotos: z.array(z.any()).optional(),
  complaintVideos: z.array(z.any()).optional(),
});

export type ReportIssueFormData = z.input<typeof reportIssueSchema>;

export interface ReportIssueFormReturn
  extends UseFormReturn<ReportIssueFormData> {
  defaultValues: ReportIssueFormData;
}

export const initialFormValues: ReportIssueFormData = {
  reason: "",
  comment: "",
  complaintPhotos: [],
  complaintVideos: [],
};

export const useReportIssueForm = (
  initialValues?: ReportIssueFormData,
): ReportIssueFormReturn => ({
  defaultValues: initialValues || initialFormValues,
  ...useForm<ReportIssueFormData>({
    mode: "onChange",
    defaultValues: initialValues,
    resolver: zodResolver(reportIssueSchema),
  }),
});
